(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracServiceDialogController', NasracServiceDialogController);

    NasracServiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracService', 'NasracSource', 'NasracProvider'];

    function NasracServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracService, NasracSource, NasracProvider) {
        var vm = this;

        vm.nasracService = entity;
        vm.isSave=false;
        if(vm.nasracService.id==null)
        {
            vm.isSave=true;
        }
        vm.clear = clear;
        vm.save = save;

        vm.clear = clear;
        vm.save = save;
        vm.nasracsources = NasracSource.query();
        vm.nasracproviders = NasracProvider.query();

        $timeout(function (){
            if(vm.isSave)
                angular.element('.form-group:eq(0)>input').focus();
            else
                angular.element('.form-group:eq(1)>select').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.isSave) {
                NasracService.save(vm.nasracService, onSaveSuccess, onSaveError);
            } else {
                NasracService.update(vm.nasracService, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracServiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
